module.exports = __webpack_public_path__ + "static/media/_curacao.485393fb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_curacao.svg
// module id = 2313
// module chunks = 7